import { useMutation, useQueryClient } from '@tanstack/vue-query'
import { rejectUserActivityTask } from './activitiesApi'
import {
  MUTATION_KEY_PRODUCTS_USER_ACTIVITY_REJECT_TASK,
  QUERY_KEY_PRODUCTS_USER_ACTIVITY_SUMMARY,
} from './activitiesKeys'

export const useRejectUserActivityTask = () => {
  const queryClient = useQueryClient()
  return useMutation({
    mutationKey: [MUTATION_KEY_PRODUCTS_USER_ACTIVITY_REJECT_TASK],
    mutationFn: rejectUserActivityTask,
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: [QUERY_KEY_PRODUCTS_USER_ACTIVITY_SUMMARY],
      })
    },
  })
}
